import api from '../index'
import {
  IAddUnit,
  IDelegateUnitToUser,
  IEditTasksDay,
  IEditUnit,
  IGetUnit,
  IGetUnitContent,
  ICreateUnitPreview,
  IPostRuleUnit,
  IRecoverUnit,
  IRemoveDelegationUserToUnit,
  IGetUnitTasksData,
  IDuplicateUnit,
  IGetUnitContentById
} from '../models/units'

export const getUnits = (data: IGetUnit) => {
  return api.get('/units', { params: data })
}

export const getUnitsKanban = (data: IGetUnit) => {
  return api.get('/units/kanban', { params: data })
}

export const getUnitsDetails = (data: IGetUnit) => {
  return api.get('/units/details', { params: data })
}

export const getUnitsExcel = (projectId: string) => {
  return api.get('/units/excel', { params: { projectId } })
}

export const addUnit = (data: IAddUnit) => {
  return api.post('/units', data)
}

export const editUnit = (data: IEditUnit) => {
  return api.put('/units', data)
}

export const delegateUnitToUser = (data: IDelegateUnitToUser) => {
  return api.post('/delegate/users', data)
}

export const removeDelegationUserToUnit = (
  data: IRemoveDelegationUserToUnit
) => {
  return api.delete('/delegate/users', { data: data })
}

export const unitEntitiesDelegate = (unitId: string) => {
  return api.get(`/units/${unitId}/delegates`)
}

export const getUnitHistoric = (unitId: string) => {
  return api.get(`/units/historic/${unitId}`)
}

export const getUnitTasks = (unitId: string, data?: IGetUnitTasksData) => {
  return api.get(`/units/${unitId}/tasks`, {
    params: data
  })
}

export const putUnitTasks = (unitId: string, taskId: string) => {
  return api.put('units/status', { unitId, taskId })
}

export const putUnitNextTask = (unitId: string) => {
  return api.put('units/status', { unitId })
}

export const archiveUnit = (unitIds: Array<string>) => {
  return api.delete('/units', {
    data: {
      ids: unitIds
    }
  })
}

export const recoverUnit = (data: IRecoverUnit) => {
  return api.patch('/units/recover', data)
}

export const editTasksDay = (data: IEditTasksDay) => {
  return api.post('/custom-task-days', data)
}

export const getUnitsContent = (data: IGetUnitContent) => {
  return api.get<IGetUnitContentById>('/units/content', { params: data })
}

export const getUnitsContentById = (id: string) => {
  return api.get(`/units/content/${id}`)
}

export const createUnitPreview = (data: ICreateUnitPreview) => {
  return api.post('/units/convertions/preview', data)
}

export const saveUnit = (data: ICreateUnitPreview) => {
  return api.post(`/units/content/${data.unitId}`, { html: data.html })
}

export const startUnit = (unitId: string) => {
  return api.put(`/units/${unitId}/start`)
}

export const convertUnit = (unitId: string) => {
  return api.post(`/units/convertions/convert`, { unitId })
}

export const postRuleUnit = (data: IPostRuleUnit) => {
  return api.post('/rules/unit', data)
}

export const getUnitShare = (unitId: string) => {
  return api.get(`/units/share/${unitId}`)
}

export const duplicateUnit = (data: IDuplicateUnit) => {
  return api.get(`/units/duplicate/${data.unitId}`)
}

export const copyUnit = (data: { unitId: string; subjectId: string }) => {
  return api.get(`/units/copy/${data.unitId}/subject/${data.subjectId}`)
}
